export const meta = () => {
  return [
    { title: "TellMeYourStory" },
    { name: "description", content: "TellMeYourStory Backend" },
  ];
};

export default function Index() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <h1 className="text-2xl font-bold">TellMeYourStory</h1>
    </div>
  );
}
